<template>
  <ClientOnly v-if="storedBooking.length">
    <el-dialog v-model="show" :title="t('unpaid_orders.title')" width="700px">
      <div class="p-4">
        <div class="mb-5">
          <el-alert
            :title="
              t('unpaid_orders.alert_message', { count: storedBooking.length })
            "
            :closable="false"
            style="margin-bottom: 20px"
          />

          <div class="max-h-96 overflow-y-auto space-y-4">
            <DefaultNotifyItem
              v-for="item in storedBooking"
              :key="item.bookingCode"
              :item="item"
            />
          </div>
        </div>

        <div class="text-center mt-5 pt-4 border-t border-gray-100">
          <el-button @click="show = false">{{
            t('unpaid_orders.close')
          }}</el-button>
        </div>
      </div>
    </el-dialog>
  </ClientOnly>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import useApi from '~/composables/request/useApi'

interface IPayment {
  totalAmount: number
  numberOfSeats: number
  bookingCode: string
  holdExpiresAt: string
  created_at: string
  payments?: [
    {
      qrUrl: string
    },
  ]
}

const { t, locale } = useI18n()
const show = ref(true)
const route = useRoute()

const storedBooking = ref<IPayment[]>([])

const { get } = useApi('booking/status')

const fetchData = async (code: string) => {
  try {
    return await get(code)
  } catch {}
}

// Check if booking is expired
const isExpired = (expiresAt: string) => {
  return new Date() < new Date(expiresAt)
}

onMounted(async () => {
  if (!route.path.includes('/payment')) {
    const raw = localStorage.getItem('bookings')
    const data: any[] = raw ? JSON.parse(raw) : []

    const newData: any[] = []

    for (const item of data) {
      if (isExpired(item.holdExpiresAt)) {
        const res: any = await fetchData(item.bookingCode)

        if (res.data.status === 'payment') {
          newData.push(item)
        }
      }
    }

    storedBooking.value = newData

    localStorage.setItem('bookings', JSON.stringify(newData))
  }
})

watch(
  () => route.path,
  () => {
    if (route.path.includes('payment')) show.value = false
  },
  {
    immediate: true,
  },
)
</script>
<style scoped>
:deep(.el-alert__title) {
  font-weight: 600;
  color: #ed1b26;
  font-size: 14px;
}
</style>
